'use client'

import { LineHelpCircle } from '@qr-front/icons/line-help-circle'
import { useState } from 'react'

import {
	captureBuilderEvent,
	STEP_TO_INDEX,
	STEP_TO_NAME,
} from '../../builderAnalytics'
import { useCurrGeneratorStep } from '../../hooks/useCurrGeneratorStep'
import { HelpDialog } from '../DialogHelp'
import {
	CreateModeGeneratorStepper,
	EditModeGeneratorStepper,
} from '../GeneratorSteppers'

export const GeneratorMobileHeaderContent = ({
	isEditMode,
	isChangeTypeMode,
}: {
	isEditMode: boolean
	isChangeTypeMode: boolean
}) => {
	const [isHelpPopupOpen, setIsHelpPopupOpen] = useState(false)
	const currStep = useCurrGeneratorStep()

	const handleHelpClick = () => {
		captureBuilderEvent('builder_click_help', {
			step_index: STEP_TO_INDEX[currStep],
			step_name: STEP_TO_NAME[currStep],
			section: 'app_header',
		})
		setIsHelpPopupOpen(true)
	}

	return (
		<>
			<div className="flex w-full items-center justify-between gap-2 desktop:hidden">
				<div className="min-w-0">
					{isEditMode ? (
						<EditModeGeneratorStepper />
					) : (
						<CreateModeGeneratorStepper
							isChangeTypeMode={isChangeTypeMode}
						/>
					)}
				</div>
				<button
					type="button"
					onClick={handleHelpClick}
					className="flex shrink-0 p-2"
				>
					<LineHelpCircle className="size-6 text-grey transition-colors duration-300 hover:text-blue" />
				</button>
			</div>
			<HelpDialog
				isOpen={isHelpPopupOpen}
				setIsOpen={setIsHelpPopupOpen}
			/>
		</>
	)
}
